/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();

  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.collectionFilter();
  timber.loginForms();
  timber.quickView();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};


timber.quickView = function () {

//     $( 'body' ).on( 'click', '#QuickViewAdd', function( e ) {
//       setTimeout( function () {
     
//       });
//     });

  $( 'body' ).on( 'click', '.product-quickview__btn, .editItem', function( e ) {
    var url = $( this ).attr( 'href' );
    var productURL = secure_url + url, data = { view: 'quickview' };
    var ifRemove = false;
    var currentLine = $(this).attr('data-line');
    var fromCartPage = 0;
    var qty = $(this).attr('data-qty');
    if($(this).hasClass('onCartPage')) { fromCartPage = 1;}

    $.get( productURL, data, function( response ) {
      $.magnificPopup.open({
        items: {
          src: response,
          type: 'inline'
        },
        type: 'inline',

        fixedContentPos: true,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-slide-bottom'
      });
      if(url.indexOf('editCart') > -1){
        $('#AddToCartText').text('Update Shopping Bag').attr('data-text','Update Shopping Bag');
        $('[name="quantity"]').val(qty);
        ifRemove = true;
      }
      
      console.log(ifRemove,'==',url.indexOf('editCart'))

      function addToCartSuccess(formid){
        $.getJSON('/cart.js', function(cart){ 
          $('.cart-nav-link .cart-count').show();
          $('.cart-nav-link .cart-count span').text(cart.item_count);
          renderHoverCart(cart);
        }).done(function( data ) {
          $('.emptyCart').remove();
          if(fromCartPage==0) {
            $('.mini-cart').show();
            $('#NavOverlay').addClass('nav-overlay--active');
            $('body').addClass('fixed'); 
          }
          $('#crt,#crt-mb').addClass('has-item');
          $('#'+formid).find('.add-to-cart-msg').hide().addClass('success').html('Item added to cart! <a href="/cart" title="view Cart">View cart and check out &raquo;</a>').fadeIn().delay(3000).fadeOut();
          setTimeout(function(){ 
            $('.mini-cart').hide();
            $('#NavOverlay').removeClass('nav-overlay--active');
            $('body').removeClass('fixed');
          }, 5000);
        });
      }
      function renderHoverCart(cart) {
        var mf = null;
        var source = $("#cartTemplate").html();
        var template = Handlebars.compile(source);
        var items = [];
        var data = {};
        $.each(cart.items, function(i,o){
          var ps = o.variant_title;

          items.push({
            id: o.id,
            vendor: o.vendor,
            title: o.product_title,
            url: o.url,
            quantity: o.quantity,
            properties : ps,
            price: Shopify.formatMoney(o.price,mf),
            image: Shopify.resizeImage(o.image,'small'),
            line: i+1
          });
        });
        data = {
          items: items,
          note: cart.note,
          totalPrice: Shopify.formatMoney(cart.total_price,mf),
        }
        $("#crt,#crt-mb").html( template(data) );
      }

  


        $('#QuickViewAdd').click(function(e){
          e.preventDefault();
          
          if(ifRemove) {
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: { line: currentLine, quantity: 0 },
              async: false,
              dataType: 'json'
            });
          }
          
          var btn = $(this);
          btn.find('span').html('<svg class="icon" enable-background="new 0 0 576 576" viewBox="0 0 576 576" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><circle cx="131" cy="288" r="31.5"/><circle cx="445.5" cy="287.5" opacity=".5" r="31.5"/><circle cx="340.5" cy="287.5" r="31.5"/><circle cx="235.5" cy="287.5" r="31.5"/></g></svg>');
          var form      = $(this).closest('form');
          var formid = $(this).closest('form').attr('id');

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: form.serialize(),
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              $('#QuickViewForm .product-single__controls').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
              setTimeout(function(){ 
                $('p.error').remove();
              }, 5000);
              if(ifRemove) {
                btn.find('span').text('Updated...');
              } else {
                btn.find('span').text('Add to shopping bag');
              }
            }
          }).done(function( data ) {
            addToCartSuccess(formid);
            
            if(ifRemove) {
              $.get('/cart?view=full', function(crt){
                $('#fullCart').html(crt);
              });
            }

            btn.find('span').html('<svg class="icon-checked" enable-background="new 0 0 576 576" viewBox="0 0 576 576" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4"><circle cx="277.5" cy="287.5" r="136.5"/><path d="m187.6 310.4 71 55.2 102.5-157"/></g></svg>');

            setTimeout(function(){ 
              if(ifRemove) {
                btn.find('span').text('Updated...');
              } else {
                btn.find('span').text('Add to shopping bag');
              }
            }, 1000);
            setTimeout(function(){ 
              $.magnificPopup.close();
            }, 1200);
            $('html, body').animate({
              scrollTop:  0
            }, 1200, function () {

            });
          });
        });



      $( '.product-quickview__btn .fa' ).removeClass( 'fa-spinner fa-pulse' ).addClass( 'fa-eye' );
            var $status = $('.pagingInfo');

     $( '.quick-view__slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
    });
      $( '.quick-view__slider' ).not( '.slick-initialized' ).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          dots: false,
          adaptiveHeight: false,
          infinite: false,
          useTransform: true,
          speed: 400,
          cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
      });


      // Load default variant image
      var imageId = $("#QuickViewForm").find(".swatch-element.color input[type='radio']:checked").parent().data("image-id");
      var $newImage = $( '.quick-view__slider' ).find('img[data-image-id="' + imageId + '"]');
      var imageIndex = $newImage.data('slick-index');
      $( '.quick-view__slider' ).slick('slickGoTo', imageIndex);

    });

      // Change variant image
        $( 'body' ).on( 'click', '.product-quickview .swatch-element.color', function( e ) {
          var imageId = $(this).data('image-id');
          var $newImage = $( '.quick-view__slider' ).find('img[data-image-id="' + imageId + '"]');
          var imageIndex = $newImage.data('slick-index');
          $( '.quick-view__slider' ).slick('slickGoTo', imageIndex);
        });


    e.preventDefault();
    e.stopPropagation();

  });


}

timber.ProductSlickSlider = function () {
  var $productImage = $('#ProductPhotoImg'),
      $productImageSlider = $('#ProductThumbs'),
      $productImageFeature = $('#ProductPhoto');

  $productImageFeature.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    vertical: false,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          dots: false,
          fade: false
        }
      }
    ]
  });

  $productImageSlider
  .on('init', function(event, slick) {
    $productImageSlider.find('.slick-slide.slick-current').addClass('is-active');
  })
  .slick({
    dots: false,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    verticalSwiping: true,
    dots: false,
    focusOnSelect: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $productImageFeature.on('afterChange', function(event, slick, currentSlide) {
    $productImageSlider.slick('slickGoTo', currentSlide);
    var currrentNavSlideElem = $productImageSlider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
    $productImageSlider.find('.slick-slide.is-active').removeClass('is-active');
    $(currrentNavSlideElem).addClass('is-active');
  });

  $productImageSlider.on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');
    $productImageFeature.slick('slickGoTo', goToSingleSlide);
  });

}


timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $productImageSlider = $('#ProductThumbs'),
      $productImageFeature = $('#ProductPhoto'),
      $addToCart = $('#AddToCart, #QuickViewAdd'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText, #QuickViewAddText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
     var newImg = variant.featured_image,
         el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);

      var $newImage = $('.product-single__photo[data-image-id="' + newImg.id + '"]');
      var imageIndex = $newImage.parents('li').data('slick-index');
     $productImageFeature.slick('slickGoTo', imageIndex);

      // Variant switching
//       var thumbIndex = variant.featured_image.position - 1;
//       $productImageFeature.slick('slickGoTo', thumbIndex);


//       var variantHash = '#img' + variant.featured_image.id;
//       $('html, body').animate({
//           scrollTop: $(variantHash).offset().top - 70,
//         }, 1000, function () {
//           // Add hash (#) to URL when done scrolling (default click behavior)
//           //window.location.hash = hash;
//       });


    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      var addtext = $addToCartText.attr('data-text');
      $addToCartText.html(addtext);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }


    // Regardless of stock, update the product price

    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
  

    // Also update and show the product's compare price if necessary

    if (variant.compare_at_price > variant.price) {
      $comparePrice
      .html("" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
      .show();
    } else {
      $comparePrice.hide();
    }


  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageZoom = function () {
  $productImageFeature = $('.product-single__photos');
    $productImageFeature.magnificPopup({
      delegate: 'a',
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom js-featured-image',
      image: {
        verticalFit: true
      },
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    });
  };

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      timber.cache.$thumbImages.removeClass("active");
      $(this).addClass("active");
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);

      /*
      timber.cache.$thumbImages.trigger('zoom.destroy');
      $('img.zoomImg').remove();
      $('#ProductPhoto').zoom({ url: newImage});
*/

    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);

  $('#js-featured-image').attr('href', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.productGridSize = function(){

  $(".product_variants li").click(function(e){

    $(this).addClass("active").siblings().removeClass('active');  

    var variantId = $(this).find('.variant_value').attr('data-variant-id');

    var varValue = $(this).parents('.product_box').find('.variants_id').val(variantId);
    var datainventory = $(this).parents('.product_box').find('.variants_id').attr('data-inventory');

    var variantId = $(this).attr('data-variant-id');
    var $addToCart = $(this).parents('#pgiAddToCartForm').find('[data-id="pgiAddToCart"]');
    $(this).parents('#pgiAddToCartForm').find('input[name="id"]').val(variantId);
    $addToCart.removeClass('disabled').prop('disabled', false);

  });
  $('.product-tile__show-variants').click(function(e){
    console.log('clicked');
    var $formContainer = $(this).parents('#pgiAddToCartForm').find('.ProductItem__addtocart');
    $('.ProductItem__addtocart').removeClass('showed');
    $formContainer.addClass('showed');
  });
  $('.product-tile__hide-variants').click(function(e){
    $('.ProductItem__addtocart').removeClass('showed');
  });
  
        var ajaxCartConfig = {
        formSelector: '#AddToCartForm,#pgiAddToCartForm',
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart,[data-id="pgiAddToCart"]',
        cartCountSelector: '#CartCount, #CartDrawerCount',
        cartCostSelector: '#CartCost',
        moneyFormat: null
      }

      jQuery(function($) {
        ajaxCart.init(ajaxCartConfig);
      });

      jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
        timber.RightDrawer.open();
      });

      jQuery('#PageContainer::before').on('click', function() {
        timber.RightDrawer.close();
      });
    var strNoDivs = $('#CollectionLoop .product-grid__item').length.toString();

$('.product__count .current_offset').text(strNoDivs);
};
timber.collectionInfinityLoad = function () {

  
  var endlessScroll = new Ajaxinate({
    container: '#CollectionLoop',
    pagination: '#CollectionPagination',
    method: 'scroll',
    callback: timber.productGridSize
  });

};  
timber.blogInfinityLoad = function () {

  
  var endlessScroll = new Ajaxinate({
    container: '#BlogLoop',
    pagination: '#BlogPagination',
    method: 'scroll'
  });

};
timber.collectionFilter = function () {
  var g = [];
  $('.filter-tag-group li.active').each(function(){
    g.push($(this).attr('data-handle'));
  });
  $(".filter-tag-group .tag-group").each(function () {
    $(this).find("ul li a").click(function (event) {
      event.preventDefault();
      var url = $(this).attr('href');
      var id = $(this).closest('.tag-group').data('id');
      if($(window).width() <= 768) {
        var li = $(this).closest('li');
        var lih = li.attr('data-handle');
        if(li.hasClass('active')) {
          g = g.filter(function(item) {
            return item !== lih
          })
          li.removeClass('active')
        } else {
          g.push(lih);
          li.addClass('active')
        }
        var fg = g.filter((c, index) => {
          return g.indexOf(c) === index;
        });
        var str = fg.join('+');
      } else {
        $.ajax({
          type: 'GET',
          url: url,
          data: {},
          beforeSend: function (xhr) {
            $("#collection-tags__load").show();
          },
          complete: function (data) {
            $('#collection-content').html($("#collection-content", data.responseText).html());
            $('.collection-sidebar').addClass('open');
            $('#' + id).addClass('open');
            history.pushState({
              page: url
            }, url, url);

            $('html, body').animate({
              scrollTop: $('#collection-content').offset().top - 180
            }, 1000, function () {
            });

            timber.collectionFilter();
            timber.collectionInfinityLoad();
            timber.productGridSize();
            $("#collection-tags__load").hide();
            $.magnificPopup.close();
          }

        });
        $(this).closest('.tag-group').addClass('open');
      }
    });
  });
  $('.btn--apply').on('click', function(e){
    e.preventDefault();
    console.log(g);
    var fg = g.filter((c, index) => {
      return g.indexOf(c) === index;
    });
    var str = fg.join('+');
    var curl = $('.filter-tag-group').attr('data-colh');
    var furl = curl+str;
     
    $.ajax({
      type: 'GET',
      url: furl,
      data: {},
      beforeSend: function (xhr) {
        $("#collection-tags__load").show();
      },
      complete: function (data) {
        $('.collection-sidebar').removeClass('open');
        $('body,html').removeClass('filtered');
        $('#collection-content').html($("#collection-content", data.responseText).html());
        history.pushState({
          page: furl
        }, furl, furl);

        $('html, body').animate({
          scrollTop: $('#collection-content').offset().top - 180
        }, 1000, function () {
        });

        timber.collectionFilter();
        timber.collectionInfinityLoad();
        timber.productGridSize();
        $("#collection-tags__load").hide();
        $.magnificPopup.close();
      }
    });
    
  });
  $('.current-tags .tag a').click(function (event) {
    event.preventDefault();
    var url = $(this).attr('href');
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function (xhr) {
        $("#collection-tags__load").show();
      },
      complete: function (data) {
        $('#collection-content').html($("#collection-content", data.responseText).html());
        history.pushState({
          page: url
        }, url, url);
        $('html, body').animate({
          scrollTop: $('#collection-content').offset().top - 180
        }, 1000, function () {

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });

        timber.collectionFilter();
        timber.collectionInfinityLoad();
        timber.productGridSize();
        $("#collection-tags__load").hide();
        $.magnificPopup.close();
      }
    });

  });
  $('#collection-tags__filter-trigger').on('click', function(){
    $('.collection-sidebar').addClass('open');
    $('body,html').addClass('filtered');
  });
//   $('#collection-tags__filter-trigger').magnificPopup({
//     type: 'inline',
//     items: {
//       src: '#collection-tags__filter'
//     },

//     fixedContentPos: true,
//     fixedBgPos: true,

//     overflowY: 'auto',

//     closeBtnInside: true,
//     preloader: false,

//     midClick: true,
//     removalDelay: 300,
//     callbacks: {
//       beforeOpen: function () {
//         // just a hack that adds mfp-anim class to markup
//         this.st.mainClass = this.st.el.attr('data-effect');
//       },
//       open: function () {
//         $.magnificPopup.instance.close = function () {
//           $.magnificPopup.proto.close.call(this);
//           $('#collection-tags__filter').removeClass('mfp-hide');
//         }

//       }

//     },
//   });
//     $('.accordion').accordion({
//       "transitionSpeed": 100,
//       singleOpen: false
//     });
      
  $('.tag-group.accordion  > h3').click(function() {

    var parent = $(this).parent();
    if($(this).parent().hasClass('open')){
      parent.removeClass('open');
    }else{
      parent.parent().find('.tag-group.accordion').removeClass('open'); 
      parent.addClass('open');

    }
  });


  $('.btn--close').on('click', function(){
    $('.collection-sidebar').removeClass('open');
    $('body,html').removeClass('filtered');
  });
};


timber.chimpLetter = function () {
  // Selectors
  var $chimpFormBtn = $('.chimp-letter__btn'),
      $chimpForm = $chimpFormBtn.closest('form.chimp-letter__form')

  //Mailchimp on Popup
  $chimpFormBtn.click(function () {
    var $this = $(this),
        $form = $this.closest('form.chimp-letter__form');

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      error: function (err) {
        alert("Could not connect to the registration server. Please try again later.");
      },
      success: function (data) {
        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -', '').replace('0 -', '');
          $form.find(".response-text").show().removeClass("success").addClass("error").html(newData);
        }
        else if (data.result == "success") {
          var data = data.msg,
            newData = data.replace('1 -', '').replace('0 -', '');
          $form.find(".response-text").show().removeClass("error").addClass("success").html(newData);
        }
      }
    });
  });

  $chimpForm.keypress(function (e) {
    if (e.which == 13) {
      $(this).find('.chimp-letter__btn').trigger("click");
      return false;
    }
  });

};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
timber.chimpLetter();
timber.ProductSlickSlider();
timber.productImageZoom();
timber.collectionInfinityLoad();
timber.blogInfinityLoad();
timber.productGridSize();